// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"802b67b0","455":"04ab75aa"}[chunkId] + ".chunk.js";
};